module.exports = __webpack_public_path__ + "img/@news_list2.4592206e.jpg";